import { Location } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, Input } from '@angular/core';


import { IProperty } from '@services/property/property-model.interfaces';
import { FormBuilderService, FormField, LoadingService, PopoverService } from '@services';
import { BaseDetailsPage } from '@modules/management/pages/details/abstractDetails/abstractBaseDetails.page';
import {
  DefaultValueComponent
} from '@modules/management/pages/details/property/components/default-value/default-value.component';


import { v4 as uuidv4 } from 'uuid';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-property-default-value-editor',
  templateUrl: './property-default-value-editor.page.html',
  styleUrls: ['./property-default-value-editor.page.scss'],
})
export class PropertyDefaultValueEditorPage extends BaseDetailsPage {
  @Input() property: IProperty;

  public title = this.translate.instant('PROPERTY.Default_Value');
  public extraFieldsNames: string[];
  private formPrefix = `defaultValue_${uuidv4()}`;
  public formId = `${this.formPrefix}Form`;
  protected newForm = {
    id: this.formId,
    cancelButton: `${this.formPrefix}Cancel`,
    saveButton: `${this.formPrefix}Save`,
    deleteButton: `${this.formPrefix}Delete`
  };

  protected addHandler = async (formData) => {
    return { reqStatus: 'OK', result: formData };
  };

  private defaultValueField = {
    type: 'customElement',
    name: 'defaultValue',
    containerClass: 'default-value',
    component: DefaultValueComponent,
    required: true,
    inputs: {}
  } as FormField;

  protected formConfig: any = {
    autocomplete: false,
    canClear: true,
    containers: true,
    prefix: this.formPrefix,
    del: null,
    save: this.translate.instant('SHARED.Save'),
    cancel: this.translate.instant('SHARED.Cancel'),
    fields: [this.defaultValueField]
  };

  constructor(
    protected route: ActivatedRoute,
    protected formBuilderService: FormBuilderService,
    protected elementRef: ElementRef,
    protected popoverService: PopoverService,
    protected location: Location,
    protected loadingService: LoadingService,
    protected translate: TranslateService,
    private modalController: ModalController
  ) {
    super(route, formBuilderService, elementRef, popoverService, location, loadingService, translate);

    this.disableBackNavigation = true;
  }

  protected getData() {
    return {
      defaultValue: this.property.defaultValue
    };
  }

  protected prepareFormConfig(): void {
    this.defaultValueField.inputs.propertyCategory = this.property.category;
    this.defaultValueField.inputs.propertyStyle = this.property.style;
    this.defaultValueField.inputs.propertySource = this.property.source;
  }

  public cancel(): void {
    this.modalController.dismiss();
  }

  public onComplete(data) {
    this.modalController.dismiss(data.defaultValue);
  }
}
